import Card from "@mui/material/Card";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/bg-reset-cover.jpeg";
import UserService from "services/UserService";

export default () => {
    const { id } = useParams();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    const passwordCompare = (value) => password === value && password.length > 3;

    const getUser = () => {
        return {
            "Guid": id,
            "Password": password,
        }
    }

    const handlePasswordValidate = (pw) => {
        setConfirmPassword(pw);

        if (!passwordCompare(pw)) {
            setError({ type: "error", value: 'As senhas deve ser iguais!' })
        } else {
            setError("")
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!passwordCompare(confirmPassword)) {
            setError({ type: "error", value: 'As senhas deve ser iguais!' })
            return
        }
        setError("");

        try {
            const userData = getUser();
            await UserService.editUser(id, userData, true)
            navigate("/login", {
                state: { message: { type: 'success', msg: 'Senha atualizada com sucesso!' } }
            });
        }
        catch (e) {
            setError({ type: "error", value: 'Falha ao atualizar senha.' });
            console.error(e);
        }
    };

    return (
        <CoverLayout coverHeight="50vh" image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    py={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
                        Definir nova senha
                    </MDTypography>
                    <MDTypography display="block" variant="button" color="white" my={1}>
                        Informe e confirme sua nova senha
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form" onSubmit={handleSubmit} >
                        <MDBox mb={4}>
                            <MDInput type="password" label="Senha" variant="standard" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth required />
                        </MDBox>
                        <MDBox mb={4}>
                            <MDInput type="password" label="Confirmar senha" variant="standard" value={confirmPassword} onChange={(e) => handlePasswordValidate(e.target.value)} fullWidth required />
                        </MDBox>
                        {error && (
                            <MDBox mt={2}>
                                <MDTypography variant="caption" color={error.type} fontWeight="light">
                                    {error.value}
                                </MDTypography>
                            </MDBox>
                        )}
                        <MDBox mt={6} mb={1}>
                            <MDButton variant="gradient" color="info" type="submit" fullWidth>
                                redefinir
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </CoverLayout>
    );
}